import { ApisauceInstance } from 'apisauce';

const sendMicrosoftGuestLinkEmail = ({
  api,
  email,
}: {
  api: ApisauceInstance;
  email: string;
}) =>
  api.post('/v1/sso/microsoft/link_guest_account', {
    email,
  });

export default sendMicrosoftGuestLinkEmail;
